import { Badge } from './Badge';

interface BackdatedIndicatorProps {
  /** Whether the date was backdated */
  isBackdated: boolean;
  /** Optional inline variant (for compact display) */
  variant?: 'badge' | 'text';
  /** Optional custom text for the indicator */
  text?: string;
}

/**
 * BackdatedIndicator - Shows a visual indicator when an order date was backdated
 *
 * Usage:
 * ```tsx
 * <BackdatedIndicator
 *   isBackdated={isOrderBackdated(frame.ordered_date, frame.created_at)}
 * />
 * ```
 */
export function BackdatedIndicator({
  isBackdated,
  variant = 'badge',
  text = 'Backdated',
}: BackdatedIndicatorProps) {
  if (!isBackdated) return null;

  if (variant === 'text') {
    return (
      <span
        className="text-xs text-orange-600 font-medium"
        title="This order date was manually set to an earlier date"
      >
        {text}
      </span>
    );
  }

  return (
    <Badge
      variant="warning"
      size="sm"
      title="This order date was manually set to an earlier date"
    >
      {text}
    </Badge>
  );
}
